import deepClone from '../../utils/deepClone'
import { getLink } from './getLink'
import { getRelationships } from './getRelationships'

export type getFormComponentsReturnType =
  | undefined
  | { component: string|undefined; identification: string|undefined; link: object|undefined }

export const getFormComponents = (data: any, included?: any): getFormComponentsReturnType => {

  if (!data) return

  const copy = deepClone(data)
  if (!copy) return

  let relationships = copy?.relationships?.field_form?.data
  relationships = Array.isArray(relationships) && relationships.length > 0 ? relationships.at(0) : relationships

  const component = relationships?.type?.replace('paragraph--','').replace('form_','')
  if (!component) return

  const id = relationships?.id
  const values = getRelationships(id, included)

  const identification = values?.attributes?.field_identification_string

  return {
    component: component,
    identification: identification,
    link: getLink(relationships, included)
  }

}